module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradOutlineW01-Rg.woff?c46de8ec2cd5b3cd5163e50c24f4b353";